// src/components/Lightbox.jsx
import { useEffect, useRef, useState } from "react";
import { cld } from "../services/cloudinaryService";
import "../styles/lightbox.css";

// 2000px basta para una pantalla 4K a lo ancho; el original de 6000px es lo que trababa todo
const FULL_W = 2000;

export default function Lightbox({ photos, index, onChange, onClose }) {
    const [loaded, setLoaded] = useState(false);
    const touchX = useRef(null);
    const total = photos.length;
    const photo = photos[index];

    const go = (delta) => onChange((index + delta + total) % total);

    // Precargar anterior y siguiente: al navegar ya están en caché
    useEffect(() => {
        setLoaded(false);
        if (total < 2) return;
        [index + 1, index - 1].forEach((i) => {
            new Image().src = cld(photos[(i + total) % total].url, FULL_W);
        });
    }, [index, photos, total]);

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
            if (total > 1 && e.key === "ArrowRight") go(1);
            if (total > 1 && e.key === "ArrowLeft") go(-1);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    });

    // Bloquear el scroll de la página detrás del visor
    useEffect(() => {
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => { document.body.style.overflow = prev; };
    }, []);

    if (!photo) return null;

    return (
        <div
            className="lb"
            role="dialog"
            aria-modal="true"
            aria-label="Visor de fotos"
            onClick={onClose}
            onTouchStart={(e) => { touchX.current = e.touches[0].clientX; }}
            onTouchEnd={(e) => {
                const dx = e.changedTouches[0].clientX - touchX.current;
                if (total > 1 && Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
            }}
        >
            <div className="lb-bar" onClick={(e) => e.stopPropagation()}>
                <span className="mono">
                    {String(index + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
                </span>
                <button className="lb-btn" onClick={onClose} aria-label="Cerrar">✕</button>
            </div>

            {!loaded && <div className="spinner lb-spinner" />}
            <img
                key={photo.url}
                src={cld(photo.url, FULL_W)}
                alt={photo.descripcion || photo.nombre || "Fotografía"}
                className={`lb-img ${loaded ? "loaded" : ""}`}
                onLoad={() => setLoaded(true)}
                onError={() => setLoaded(true)}
                onClick={(e) => e.stopPropagation()}
            />

            {total > 1 && (
                <>
                    <button className="lb-btn lb-nav prev" onClick={(e) => { e.stopPropagation(); go(-1); }} aria-label="Foto anterior">‹</button>
                    <button className="lb-btn lb-nav next" onClick={(e) => { e.stopPropagation(); go(1); }} aria-label="Foto siguiente">›</button>
                </>
            )}

            {photo.descripcion && (
                <p className="lb-caption" onClick={(e) => e.stopPropagation()}>{photo.descripcion}</p>
            )}
        </div>
    );
}
